module.exports = __webpack_public_path__ + "static/media/RB062RED.d7f39b32.webp";